export default __webpack_public_path__ + "static/blog-03-1170x600-2835af889b30644b8dace44f4ef53f11.jpg";